import { render } from "./additional-services.vue?vue&type=template&id=1ff22c51"
import script from "./additional-services.js?vue&type=script&lang=js"
export * from "./additional-services.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__